module.exports = __webpack_public_path__ + "static/img/q3.0801aa97.jpg";